import script from "./ClsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClsPage.vue?vue&type=script&setup=true&lang=js"

import "./ClsPage.vue?vue&type=style&index=0&id=e213d43e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e213d43e"]])

export default __exports__